import React, { useEffect, useState, useRef } from 'react';
import {
    Fade,
    SvgIcon,
    AppBar, Toolbar,
    Box,
    Button,
    Container,
    Dialog,
    Divider,
    Drawer,
    Grid,
    IconButton,
    Stack,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material'

import { v4 as uuidv4 } from 'uuid';
import { ObjectId } from 'bson';

import { useLocation, useNavigate } from 'react-router-dom';
import { getBasicProfileDetails, getResumesData, setResumesData, updateResumeData } from 'api/users';

import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';

import { useSnackbar } from 'components/snackbar';
import { useAuth } from 'hooks/useAuthContext';
import { SplashScreen } from 'components/loading-screen';

import CandidateResume from 'components/basic-profile/CandidateResume';
import WorkExperienceDetails from 'components/basic-profile/WorkExperienceSection';
import CertificationSection from 'components/basic-profile/CertificationSection';
import EducationSection from 'components/basic-profile/EducationSection';
import ContactDetails from 'components/basic-profile/ContactDetails';
import PersonalDetails from 'components/basic-profile/PersonalDetails';
import ProfessionalSummary from 'components/basic-profile/ProfessionalSummary';
import CustomSection from 'components/basic-profile/CustomSection';
import UploadProfile from 'components/basic-profile/UploadProfile';
import LeaveWithoutUpdatingDialog from 'components/basic-profile/LeaveWithoutUpdatingDialog';
import FinanceTechnicalCompetencies from 'components/basic-profile/FinanceTechnicalCompetencies'
import TotalWorkExperienceDisplay from 'components/basic-profile/TotalWorkExperienceDisplay';
import UploadExistingProfile from 'components/basic-profile/UploadExistingProfile';
import Disability from 'components/basic-profile/Disability';
import IncompleteSectionDialog from 'components/basic-profile/IncompleteSectionDialog';

import CareerBreaksIdentifiedDialog from 'components/basic-profile/CareerBreaksIdentifiedDialog';
import { calcWorkGap } from 'utils/workGapCalc';
import { useBackNavigationDialog } from 'hooks/useBackNavigationDialog';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Fade ref={ref} {...props} />;
});

/**
 * CreateUpdateResume is a React component that handles the creation and updating
 * of a user's resume. It provides a form interface to input various sections 
 * of a resume, such as personal details, education, work experience, certifications, 
 * and more. It also includes functionality to manage state changes, handle data 
 * fetching, validation, and updating processes. The component is designed to be 
 * responsive and adapts its layout based on the device's screen size.
 */

const CreateUpdateResume = () => {
    const { updateContext, jobApply, setJobApply } = useAuth();
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const { data, totalResume, tab, jobData, createNewResume, isDuplicate, uploadResume, isMaster, isExternalJob } = location.state || { data: null, totalResume: 0, tab: '4', jobData: null, createNewResume: false, isDuplicate: false, uploadResume: false };
    const [isMasterResume, setIsMasterResume] = useState(data?._id === data?.original_id || false);
    const [notChanged, setNotChanged] = useState(false);
    const navigate = useNavigate();
    const [initialData, setInitialData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loads, setLoads] = useState(false);
    const [resumeId, setResumeId] = useState(data?._id ?? '');
    const [resumeTitleText, setResumeTitleText] = useState(data ? (data?.title || '') : `Master Resume`);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [expandedSection, setExpandedSection] = useState({ section: null, index: null });
    const [flag, setFlag] = useState(true);
    const [isEditResumeTitle, setIsEditResumeTitle] = useState(false);
    const [isEditTitle, setIsEditTitle] = useState(true);
    const [deleteEducationHistoryIds, setDeleteEducationHistoryIds] = useState([]);
    const [deleteCertificateHistoryIds, setDeleteCertificateHistoryIds] = useState([]);
    const [deleteWorkHistoryIds, setDeleteWorkHistoryIds] = useState([]);
    const [isClicked, setIsClicked] = useState(false);
    // const [previewResume, setPreviewRsume] = useState(false);
    const [showFirstButton, setShowFirstButton] = useState(true);
    const personalDetailRef = useRef(null);
    const [updating, setUpdating] = useState(false);
    const [resume, setResume] = useState('');
    const [candidateData, setCandidateData] = useState('');
    const [resumeLink, setResumeLink] = useState('');
    const [customSection, setCustomSection] = useState(data?.profile?.custom_section ?? []);
    const [profile, setProfile] = useState(data?.profile ?? {});
    const [educations, setEducations] = useState(data?.educations ?? []);
    const [workHistory, setWorkHistory] = useState(data?.work_history ?? []);
    const [certificates, setCertificates] = useState(data?.certificates ?? []);
    const [summary, setSummary] = useState(data?.summary || data?.profile?.summary || '');
    const [financeTechologiesData, setfinanceTechologiesData] = useState(data?.profile?.finance_technologies ?? []);

    // const [isUpdateContactOpen, setIsUpdateContactOpen] = useState(false);
    const [contactToUpdate, setContactToUpdate] = useState('');
    const [profilephoto, setProfilePhoto] = useState([]);
    const [contactDetailsError, setContactDetailsError] = useState();

    // const [withoutUpdateDialog, setLeaveWihoutUpdatingDialog] = useState(false);
    const [allResumeTitle, setAllResumeTitle] = useState([]);
    const [isChange, setIsChange] = useState(false);
    const [resumeWordLink, setResumeWordLink] = useState(null);
    // const [openIncompleteDialog, setOpenIncompleteDialog] = useState(false);

    const scrollableContainerRef = useRef(null);
    // const [openCareerGapDialog, setOpenCareerGapDialog] = useState(false);
    const [workExperienceGap, setWorkExperienceGap] = useState([]);

    const [isCreatedMasterResume, setIsCreatedMasterResume] = useState(false);
    const [isUpdateInEduAndCerti, setIsUpdateInEduAndCerti] = useState(false);

    useEffect(() => {
        if (initialData === null) {
            return;
        }

        const currentState = {
            resumeTitleText,
            profile,
            summary,
            educations,
            workHistory,
            certificates,
            financeTechologiesData,
            customSection,
            resumeLink,
        };

        const hasChanged = JSON.stringify(initialData) !== JSON.stringify(currentState);

        setIsChange(hasChanged);

    }, [
        initialData,
        resumeTitleText,
        profile,
        summary,
        educations,
        workHistory,
        certificates,
        financeTechologiesData,
        customSection,
        resumeLink
    ]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowFirstButton(false);
        }, 10000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (data && notChanged) {
            setLoading(false);
            return;
        }
        if (!data && totalResume === 5) {
            setLoading(false);
            navigate('/home', { state: { tab: tab || '4', data: jobData || null } });
            return;
        }
        if (createNewResume)
            fetchData();
        else if (!notChanged) {
            fetchData(data?._id);
        } else
            setLoading(false);
    }, []);

    useEffect(() => {
        console.log(isUpdateInEduAndCerti, isChange);
        if (isChange && isUpdateInEduAndCerti) workGapAnalysis();
    }, [isUpdateInEduAndCerti]);

    // useEffect(() => {
    //     let filterWithoutReason = [];
    //     const workGapList = workHistory.filter(edu => edu?.organization_name === 'Work Gap');
    //     if (workGapList?.length > 0) {
    //         filterWithoutReason = workGapList.filter(edu => !edu?.gap_explaination || !edu?.gap_title);
    //         if (filterWithoutReason?.length > 0) {
    //             setWorkExperienceGap(filterWithoutReason);
    //         }
    //     }
    //     if (filterWithoutReason && filterWithoutReason.length > 0) {
    //         setOpenCareerGapDialog(true);
    //         setLoads(false);
    //         return;
    //     }
    // }, [workHistory, educations, certificates]);

    /**
     * Opens the LeaveWithoutUpdatingDialog if there are changes to the resume, it's a new resume, or if the user is duplicating or creating a master resume.
     * Otherwise, navigates to the home page with the selected tab and resumeId.
     */
    const handleOpenLeaveWihoutUpdatingDialog = () => {
        if (isChange || createNewResume || isDuplicate || isMaster) openDialog('withoutUpdateDialog');
        else {
            if (jobApply?.openChatBot) navigate('/home');
            else navigate('/home', { state: { tab: '4', resumeId, data: jobData || null } });
        }
    };
    /**
     * Closes the Leave Without Updating dialog.
     * Sets the dialog state to false, effectively closing it.
     */

    const handleCloseLeaveWihoutUpdatingDialog = () => {
        closeDialog('withoutUpdateDialog');
    };

    /**
     * Fetches the user's profile, resume, and detailed resume data. Also fetches all the resume titles other than the one being edited.
     * If the resume does not exist, it fetches the basic profile details and sets the candidate data and profile.
     * If the resume is new and not master, generates a unique title for the resume.
     * Sets the resume title, educations, work history, certificates, summary, finance technologies, custom section, and resume link.
     * @param {string} [id=null] The resume id to fetch. If not provided, it fetches the master resume id from the candidate details.
     * @returns {Promise<void>}
     */
    const fetchData = async (id = null) => {
        try {
            const profileRes = await getBasicProfileDetails();
            const { success: profileSuccess, data: profileData } = profileRes || {};
            const candidate = profileData?.candidate;
            const profile = profileData?.profile;

            if (!profileSuccess || !candidate) {
                enqueueSnackbar('Failed to fetch basic profile details', { variant: 'error' });
                return;
            }

            setCandidateData(candidate);
            setProfile(profile);
            setIsCreatedMasterResume(candidate?.is_master_resume);

            const resumeIdToFetch = id || (isMaster ? candidate.master_resume_id : null);
            const resumeRes = await setResumesData(resumeIdToFetch ? { id: resumeIdToFetch } : undefined);
            const { success: resumeSuccess, data: resumeData, message } = resumeRes || {};

            if (!resumeSuccess || !resumeData || !resumeData._id) {
                enqueueSnackbar(message || 'Failed to fetch resume', { variant: 'error' });
                navigate('/home', { state: { tab: tab || '4', data: jobData || null } });
                return;
            }

            const resumeId = resumeData._id;

            const allResumesRes = await getResumesData();

            const { success: allSuccess, data: allResumes } = allResumesRes || {};

            if (!allSuccess || !Array.isArray(allResumes)) {
                enqueueSnackbar('Failed to fetch detailed resume data', { variant: 'error' });
                return;
            }

            const { success: currentSuccess, data: currentResume } = await getResumesData({ id: resumeId });

            if (!currentSuccess && !currentResume) {
                enqueueSnackbar('Resume not found in list', { variant: 'error' });
                return;
            }

            const otherResumeTitles = allResumes
                .filter(r => r._id !== resumeId)
                .map(r => r.title?.trim() || '');

            setAllResumeTitle(otherResumeTitles);

            const {
                _id,
                original_id,
                educations: fetchedEducations = [],
                work_history: fetchedWorkHistory = [],
                certificates: fetchedCertificates = [],
                summary: fetchedSummary = '',
                title: fetchedTitle,
                finance_technologies: fetchedFinanceTech = [],
                custom_section: fetchedCustomSection = null,
                link: fetchedResumeLink = '',
                status,
                word_link: fetchedWordLink = ''
            } = currentResume;

            setEducations(fetchedEducations);
            setWorkHistory(fetchedWorkHistory);
            setCertificates(fetchedCertificates);
            setSummary(fetchedSummary);
            setResumeLink(fetchedResumeLink);
            setResumeWordLink(fetchedWordLink);

            setIsMasterResume(_id === original_id);
            setResumeId(resumeId);
            setIsEditResumeTitle(false);
            setIsEditTitle(true);

            setfinanceTechologiesData(fetchedFinanceTech);
            setCustomSection(fetchedCustomSection);

            let initialTitle = fetchedTitle;
            if (status === 'new' && _id !== original_id && !isMaster && !currentResume?.link) {
                initialTitle = generateUniqueResumeTitle(fetchedTitle, otherResumeTitles);
            }
            setResumeTitleText(initialTitle);

            if (initialData === null) {
                setInitialData({
                    resumeTitleText: initialTitle,
                    profile,
                    summary: fetchedSummary,
                    educations: fetchedEducations,
                    workHistory: fetchedWorkHistory,
                    certificates: fetchedCertificates,
                    financeTechologiesData: fetchedFinanceTech,
                    customSection: fetchedCustomSection,
                    resumeLink: fetchedResumeLink,
                });
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            enqueueSnackbar('Error fetching data', { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    /**
     * Generates a unique resume title using "nested" versioning.
     * If a title is a duplicate, it appends a new version suffix to the *entire* existing title.
     * Example: A copy of "My Resume -V1" becomes "My Resume -V1 -V1".
     *
     * @param {string} title The title the user wants to use.
     * @param {string[]} existingTitles An array of titles that are already in use.
     * @returns {string} A unique title.
     */
    const generateUniqueResumeTitle = (title, existingTitles) => {
        let base = title;

        while (true) {
            const regex = new RegExp(`^${base} -V(\\d+)$`);
            const matchingVersions = existingTitles
                .map(t => {
                    const match = t.match(regex);
                    return match ? parseInt(match[1]) : null;
                })
                .filter(v => v !== null);

            let nextVersion = 1;
            if (matchingVersions.length > 0) {
                nextVersion = Math.max(...matchingVersions) + 1;
            }

            const newTitle = `${base} -V${nextVersion}`;

            if (!existingTitles.includes(newTitle)) {
                return newTitle;
            }

            base = newTitle;
        }
    };

    const { openDialog, closeDialog, dialogLocation } = useBackNavigationDialog();
    const dialogIds = dialogLocation.state?.dialogIds || [];

    const previewResume = dialogIds.includes("previewResume");
    const isUpdateContactOpen = dialogIds.includes("updateContact");
    const openCareerGapDialog = dialogIds.includes("openCareerGapDialog");
    const openIncompleteDialog = dialogIds.includes("openIncompleteDialog");
    const withoutUpdateDialog = dialogIds.includes("withoutUpdateDialog");

    /**
     * Closes the resume preview dialog.
     */
    const handlePreviewResumeClose = () => {
        // setPreviewRsume(false);
        closeDialog('previewResume');
    };
    const handlePreviewResumeOpen = () => {
        // setPreviewRsume(true);
        openDialog('previewResume');
    };
    const handleOpenUpdateContactDialog = () => {
        openDialog('updateContact');
    };
    const handleCloseUpdateContactDialog = () => {
        closeDialog('updateContact');
    };
    const handleOpenCareerBreakDialog = () => {
        openDialog('openCareerGapDialog');
    };
    const handleCloseCareerBreakDialog = () => {
        closeDialog('openCareerGapDialog');
    };
    const handleOpenIncompleteDialog = () => {
        openDialog('openIncompleteDialog');
    };
    const handleCloseIncompleteDialog = () => {
        closeDialog('openIncompleteDialog');
    };

    /**
     * Checks if local data is empty by ensuring that all values are either null, undefined, empty strings, or empty arrays.
     * @param {Object} data The data to check.
     * @returns {boolean} true if all values are empty, false otherwise.
     */
    const checkLocalDataIsEmpty = (data) => {
        if (data) {
            return Object.values(data)?.every(value =>
                value === null ||
                value === undefined ||
                (typeof value === 'string' && value.trim() === '') ||
                (Array.isArray(value) && value.length === 0)
            );
        }
    };

    /**
     * Sets the `isEditResumeTitle` state to true and `isEditTitle` to false. This is used to toggle the edit title
     * section of the resume dialog to the edit resume title section.
     */
    const handleEditResumeTitle = () => {
        setIsEditResumeTitle(true);
        setIsEditTitle(false);
    };

    /**
     * Cancels the current editing section and restores unsaved data from local storage.
     * If the expanded section is "education", "certificate", or "work",
     * it retrieves unsaved data from local storage and merges it with the existing data,
     * provided the unsaved data is not empty. The expanded section is then reset.
     */

    const handleCancelEducation = () => {
        setExpandedSection((prev) => {
            if (prev?.section === "education") {
                const eduUnsavedData = localStorage.getItem("education") ? JSON.parse(localStorage.getItem("education")) : null;
                setEducations([...educations?.filter(edu => edu?._id), ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])])
            }
            if (prev?.section === "certificate") {
                const eduUnsavedData = localStorage.getItem("certificate") ? JSON.parse(localStorage.getItem("certificate")) : null;
                setCertificates([...certificates?.filter(edu => edu?._id), ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])])
            }
            if (prev?.section === "work") {
                const eduUnsavedData = localStorage.getItem("workExperience") ? JSON.parse(localStorage.getItem("workExperience")) : null;
                setWorkHistory([...workHistory?.filter(edu => edu?._id), ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])])
            }
            return { section: null, index: null }
        });
    };
    /**
     * Scrolls to a specific child element within the scrollable container.
     * @param {string} targetId The ID of the element to scroll to.
     * @example
     * scrollToChild('education-section');
     */
    const scrollToChild = (targetId) => {
        if (scrollableContainerRef.current) {
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }
    };
    /**
     * Resets the expanded section state to null when the certificate data changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after adding or editing a certificate.
     */
    const handleCertificateDataChange = () => {
        setExpandedSection({ section: null, index: null });
    };

    /**
     * Resets the expanded section state to null when the work experience data changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after adding or editing a work experience.
     */
    const handleWorkExperienceDataChange = () => {
        setExpandedSection({ section: null, index: null });
    };

    /**
     * Resets the expanded section state to null when the professional summary data changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after editing the professional summary.
     * @param {Object} data Object containing the professional summary data.
     */
    const handleSummaryDataChange = (data) => {
        // setSummary(data?.summary || '');
    };

    /**
     * Resets the expanded section state to null when the finance data changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after editing the finance data.
     */
    const handleFinanceDataChange = () => {
        // fetchData(data?._id);
    };

    /**
     * Resets the expanded section state to null when the custom section data changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after adding or editing a custom section.
     * @async
     */
    const handleCustomSectionDataChange = async () => {
        setFlag(false);
        // fetchData(data?._id);
    };

    /**
     * Resets the expanded section state to null when the profile photo changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after editing the profile photo.
     */
    const handleProfilePhotoChange = () => {
        // fetchData(data?._id);
    };

    /**
     * Resets the expanded section state to null when the education data changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after editing the education section.
     */

    const handleEducationDataChange = () => {
        setExpandedSection({ section: null, index: null });
        // fetchData(data?._id);

    };

    /**
     * Handles the expand event of the section accordion. When the section
     * is expanded, it checks if there is any unsaved data in local storage
     * for the corresponding section (education, certificate, work) and if
     * so, it adds the unsaved data to the respective state (educations,
     * certificates, workHistory). If the section is already expanded, it
     * returns a state with section and index set to null, which will close
     * the expanded section.
     * @param {string} section The name of the section (education, certificate, work)
     * @param {number} index The index of the item in the section
     */
    const handleExpand = (section, index) => {
        setExpandedSection((prev) => {
            if (!(prev.section === section && prev.index === index)) {
                if (prev?.section === "education") {
                    const eduUnsavedData = localStorage.getItem("education") ? JSON.parse(localStorage.getItem("education")) : null;
                    setEducations([...educations?.filter(edu => edu?._id), ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])])
                }
                if (prev?.section === "certificate") {
                    const eduUnsavedData = localStorage.getItem("certificate") ? JSON.parse(localStorage.getItem("certificate")) : null;
                    setCertificates([...certificates?.filter(edu => edu?._id), ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])])
                }
                if (prev?.section === "work") {
                    const eduUnsavedData = localStorage.getItem("workExperience") ? JSON.parse(localStorage.getItem("workExperience")) : null;
                    setWorkHistory([...workHistory?.filter(edu => edu?._id), ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])])
                }
                return { section, index }
            } else {
                return { section: null, index: null }
            }
        });
    };

    /**
     * Handles the show action of the education section. If the title is "Education",
     * it removes the local storage item for education and sets the educations state
     * by either updating an existing education item (if it already has an ID) or
     * by adding a new education item. After setting the educations state, it sets
     * the expanded section state to null.
     * @param {string} title The title of the section (e.g. "Education")
     * @param {Object} newData The new education data
     */
    const handleShowEdu = (title, newData) => {
        if (title === "Education") {
            localStorage.removeItem('education');

            setEducations(prevEducations => {
                const hasId = !!newData._id;
                setIsChange(true);

                if (hasId) {
                    const existsIndex = prevEducations.findIndex(edu => edu._id === newData._id);
                    if (existsIndex !== -1) {
                        return prevEducations.map((edu, index) =>
                            index === existsIndex ? newData : edu
                        );
                    }
                }
                const filteredEducations = prevEducations.filter(edu => edu._id && edu.status === 'active');
                const newEdu = { ...newData, _id: new ObjectId().toString(), isNew: true, status: 'active' };
                let updatedEduData = [...filteredEducations, newEdu];
                updatedEduData = updatedEduData.sort((a, b) => {
                    return new Date(b.education_from) - new Date(a.education_from);
                });
                return updatedEduData;
            });
            workGapAnalysis();
            setExpandedSection({ section: null, index: null });
            setIsUpdateInEduAndCerti(true);
        }
    };

    /**
     * Handles the delete action of the education section. When the delete action
     * is triggered, it adds the ID of the education item to be deleted to the
     * deleteEducationHistoryIds state and filters out the education item from
     * the educations state. It also sets the expanded section state to null.
     * @param {string} id The ID of the education item to be deleted.
     */
    const handleEducationDelete = (id) => {
        const newUpdatedEduId = educations.filter(doc => doc._id === id && !doc?.isNew).map(doc => doc._id);
        if (newUpdatedEduId.length > 0) setDeleteEducationHistoryIds(prevIds => [...prevIds, ...newUpdatedEduId]);
        // setDeleteEducationHistoryIds(prevIds => [...prevIds, id]);
        setEducations(prevEducations => {
            return prevEducations.filter(edu => edu._id !== id);
        });
        workGapAnalysis();
        setExpandedSection({ section: null, index: null });
        setIsUpdateInEduAndCerti(true);
    };



    /**
     * Handles the display logic for certificates. If the title is "certificate",
     * it removes any existing certificate from local storage, and updates the
     * certificates state by either replacing an existing certificate with matching
     * ID or adding a new certificate with a unique ID. It also resets the 
     * expanded section state to null.
     * 
     * @param {string} title - The title indicating the type of data, expected to be "certificate".
     * @param {Object} newData - The new certificate data to be added or updated.
     */

    const handleShowCert = (title, newData) => {
        if (title === "certificate") {
            localStorage.removeItem('certificate');

            setCertificates(prevCertificates => {
                const hasId = !!newData._id;

                if (hasId) {
                    const existsIndex = prevCertificates.findIndex(cert => cert._id === newData._id);
                    if (existsIndex !== -1) {
                        return prevCertificates.map((cert, index) =>
                            index === existsIndex ? newData : cert
                        );
                    }
                }
                const filteredCerts = prevCertificates.filter(cert => cert._id && cert.status === 'active');
                const newCert = { ...newData, _id: new ObjectId().toString(), isNew: true, status: 'active' };
                let newCertData = [...filteredCerts, newCert];
                newCertData = newCertData.sort((a, b) => {
                    return new Date(b.education_to) - new Date(a.education_to);
                });
                return newCertData;
            });
            workGapAnalysis();

            setExpandedSection({ section: null, index: null });
            setIsUpdateInEduAndCerti(true);
        }
    };

    /**
     * Handles the delete action of the certificates section. When the delete action
     * is triggered, it adds the ID of the certificate to be deleted to the
     * deleteCertificateHistoryIds state and filters out the certificate from
     * the certificates state. It also resets the expanded section state to null.
     * @param {string} id The ID of the certificate item to be deleted.
     */
    const handleDeleteCert = (id) => {
        const oldUpdatedCertificateId = certificates.filter(doc => doc._id === id && !doc?.isNew).map(doc => doc._id);
        if (oldUpdatedCertificateId.length > 0) setDeleteCertificateHistoryIds(prevIds => [...prevIds, ...oldUpdatedCertificateId]);

        setCertificates(prevCertificates => {
            return prevCertificates.filter(cert => cert._id !== id);
        });
        workGapAnalysis();

        setExpandedSection({ section: null, index: null });
        setIsUpdateInEduAndCerti(true);
    };

    /**
     * Handles the show action of the work experience section. When the show action
     * is triggered, it adds the new work experience data to the workHistory state
     * and resets the expanded section state to null.
     * @param {string} title The title of the section to be shown.
     * @param {object} newData The new work experience data to be added.
     */
    const handleShowWork = (title, newData) => {
        // console.log(title, newData);

        if (newData?.industry_sector) {
            newData.organization_details = {
                ...newData?.organization_details,
                industry_sector: newData?.industry_sector,
            };
        }

        if (title === "WorkHistory") {
            localStorage.removeItem('workExperience');

            setWorkHistory(prevWorkHistories => {
                const hasId = !!newData?._id;
                let updatedHistories;

                if (hasId) {
                    const existsIndex = prevWorkHistories.findIndex(work => work?._id?.toString() === newData?._id?.toString());
                    if (existsIndex !== -1) {
                        // Update existing record
                        updatedHistories = prevWorkHistories.map((work, index) =>
                            index === existsIndex ? newData : work
                        );
                        return reorderWorkHistory(updatedHistories.filter(work => work?._id && work.status === 'active'));
                    }
                }

                // If new entry
                const filteredWorkHistories = prevWorkHistories.filter(work => work._id && work.status === 'active');
                const newWork = { ...newData, _id: new ObjectId().toString(), isNew: true, status: 'active' };
                updatedHistories = [...filteredWorkHistories, newWork];
                const workOrder = reorderWorkHistory(updatedHistories);
                // console.log(workOrder);
                return workOrder;
            });
            if (newData?.organization_name !== 'Work Gap') workGapAnalysis();
            setExpandedSection({ section: null, index: null });
        }
    };

    const reorderWorkHistory = (workHistory) => {
        if (!Array.isArray(workHistory) || workHistory.length === 0) return [];

        const presentJobs = workHistory.filter(job => job.present);
        const pastJobs = workHistory.filter(job => !job.present);

        // Get the job with the latest 'work_history_to' date
        const latestPastJob = pastJobs.reduce((latest, job) => {
            const jobDate = new Date(job.work_history_to || 0);
            const latestDate = latest ? new Date(latest.work_history_to || 0) : new Date(0);
            return jobDate > latestDate ? job : latest;
        }, null);

        const remainingPastJobs = pastJobs.filter(job => job !== latestPastJob);

        // Sort remaining jobs by 'work_history_from' in descending order
        remainingPastJobs.sort((a, b) => new Date(b.work_history_from || 0) - new Date(a.work_history_from || 0));

        return [
            ...presentJobs,
            ...(latestPastJob ? [latestPastJob] : []),
            ...remainingPastJobs,
        ];
    };

    const handleWorkGapChange = (newData) => {
        // console.log(newData); // Make sure newData is an array

        setWorkHistory(prevWorkHistories => {
            const updatedWorkHistories = [...prevWorkHistories];

            // Loop through each entry in newData array
            newData.forEach(entry => {
                const { workId, ...rest } = entry;
                const hasId = !!workId;

                if (hasId) {
                    // Check if the entry already exists
                    const existsIndex = updatedWorkHistories.findIndex(work => work?._id?.toString() === workId?.toString());
                    if (existsIndex !== -1) {
                        updatedWorkHistories[existsIndex] = rest; // Update existing
                        return;
                    }
                }

                // Add new entry with new ID
                const newWork = {
                    ...rest,
                    _id: new ObjectId().toString(),
                    isNew: true,
                    status: 'active'
                };
                updatedWorkHistories.push(newWork);
            });

            // Filter and reorder only active entries
            const filteredWorkHistories = updatedWorkHistories.filter(work => work._id && work.status === 'active');
            const workOrder = reorderWorkHistory(filteredWorkHistories);
            // console.log(workOrder);
            return workOrder;
        });

        setExpandedSection({ section: null, index: null });
    };

    const workGapAnalysis = () => {

        setWorkHistory(prev => {
            // Make a safe copy
            let updatedWorkHistory = structuredClone(prev);

            // ✅ Replace backend queries with props/state variables
            const workHistoryList = updatedWorkHistory; // Already in state
            const educationList = educations.filter(
                edu => edu?.learning_format === 'Full time - offline'
            );
            const certificationList = certificates.filter(
                cert => cert?.learning_format === 'Full time - offline'
            );

            // Separate gaps and non-gaps
            const existingGaps = workHistoryList.filter(
                h => h.organization_name === 'Work Gap'
            );
            const pureWorkHistories = workHistoryList.filter(h => h.organization_name !== 'Work Gap' && h.job_type?.toLowerCase() !== 'internship');


            if (pureWorkHistories.length > 0 && (!resumeLink || candidateData?.is_master_resume)) {
                console.log('Work Gap Analysis');
            } else {
                return workHistoryList;
            }

            // Call your gap calculation logic
            let { updatedHistories, retainedGaps } = calcWorkGap(
                pureWorkHistories,
                educationList,
                certificationList,
                existingGaps,
            );

            // Mark retained gaps for the frontend
            retainedGaps = retainedGaps.map(rWg => ({
                ...rWg,
                status: 'active',
                _id: new ObjectId().toString(),
                isNew: true,
            }));


            // ----- FRONTEND REPLACEMENT FOR BACKEND DELETE/INSERT -----

            // 1. Delete old gaps
            const oldWorkGapsIds = existingGaps.map(doc => doc._id);
            const oldUpdatedGapIds = existingGaps.filter(doc => doc._id && !doc?.isNew).map(doc => doc._id);
            setDeleteWorkHistoryIds(prevIds => [...prevIds, ...oldUpdatedGapIds]);
            updatedWorkHistory = updatedWorkHistory.filter(
                w => !oldWorkGapsIds.includes(w._id)
            );

            // 2. Insert new gaps
            updatedWorkHistory = [...updatedWorkHistory, ...retainedGaps];
            console.log(updatedWorkHistory);
            return reorderWorkHistory(updatedWorkHistory);
        });

        return true;
    };

    /**
     * Handles the deletion of a work experience item.
     * Adds the ID of the work experience to be deleted to the deleteWorkHistoryIds state
     * and filters out the work experience from the workHistory state.
     * Resets the expanded section state to null.
     * @param {string} id - The ID of the work experience item to be deleted.
     */

    const handleDeleteWorks = (id) => {
        const newUpdatedWorkId = workHistory.filter(doc => doc._id === id && !doc?.isNew).map(doc => doc._id);
        if (newUpdatedWorkId.length > 0) setDeleteWorkHistoryIds(prevIds => [...prevIds, ...newUpdatedWorkId]);
        // setDeleteWorkHistoryIds(prevIds => [...prevIds, id]);
        setWorkHistory(prevWorkHistory => {
            return prevWorkHistory.filter(work => work?._id?.toString() !== id?.toString());
        });
        setExpandedSection({ section: null, index: null });
        workGapAnalysis();
    };

    /**
     * Handles the updating of finance technologies data.
     * Updates the financeTechologiesData state with the new data.
     * Resets the expanded section state to null.
     * @param {string} title - The title of the section being updated.
     * @param {object} newData - The new finance technologies data to be updated.
     */
    const handleFinance = (title, newData) => {
        if (title === "financeTechologiesData") {
            setfinanceTechologiesData(newData);
            setExpandedSection({ section: null, index: null });
        }
    };

    /**
     * Updates the professional summary state with the new summary data.
     * If the title matches "Professional Summary", it sets the summary
     * and resets the expanded section state.
     *
     * @param {string} title - The title indicating the section to be updated.
     * @param {object} newData - The new data containing the updated summary.
     */

    const handleSummary = (title, newData) => {
        const newSummary = newData.summary;
        if (title === "Professional Summary") {
            setSummary(newSummary);
            setExpandedSection({ section: null, index: null });
        }
    };

    /**
     * Handles the updating of the custom section data.
     * When the title matches "Custom", it updates the customSection state with the new data.
     * Resets the expanded section state to null.
     * @param {string} title - The title indicating the section to be updated.
     * @param {object} newData - The new data containing the updated custom section data.
     */
    const handleCustom = (title, newData) => {

        if (title === "Custom") {
            setCustomSection(prevCustomSection => {
                const updatedSection = prevCustomSection ? [...prevCustomSection] : [];

                newData.forEach(newItem => {
                    const itemId = newItem.id || new ObjectId().toString();

                    const existsIndex = updatedSection.findIndex(item => item.id === itemId);

                    if (existsIndex !== -1) {
                        updatedSection[existsIndex] = { ...newItem, id: itemId, status: 'active' };
                    } else {
                        updatedSection.push({ ...newItem, id: itemId, status: 'active' });
                    }
                });

                return updatedSection;
            });

            setExpandedSection({ section: null, index: null });
        }
    };
    /**
     * Handles the deletion of a custom section.
     * Filters out the custom section with the matching id from the customSection state.
     * Resets the expanded section state to null.
     * @param {string} id - The id of the custom section to delete.
     */
    const handleDeleteCustom = (id) => {
        setCustomSection(prevCustomSection => {
            return prevCustomSection.filter(item => item.id !== id);
        });
        setExpandedSection({ section: null, index: null });
    };

    /**
     * Updates the profile state with the provided profile data.
     * Merges the existing profile state with the new profile data
     * and resets the expanded section state to null.
     *
     * @param {object} profileData - The new profile data to be merged into the existing profile state.
     */

    const handleResumeProfile = (profileData) => {
        setProfile(prevProfile => ({ ...prevProfile, ...profileData }));
        setExpandedSection({ section: null, index: null });
    };
    /**
     * Updates the resume links and resets the expanded section state.
     * Takes a URL object and sets the resumeLink and resumeWordLink
     * states with the provided links. Finally, it resets the expanded
     * section state to null.
     *
     * @param {Object} url - The URL object containing resume links.
     * @param {string} url.resumeUrl - The URL of the resume.
     * @param {string} url.wordLink - The URL of the Word document.
     */

    const handleUploadResume = (url) => {
        setResumeLink(url?.resumeUrl);
        setResumeWordLink(url?.wordLink);
        setExpandedSection({ section: null, index: null });
    };
    const handleTotalWorkExperience = (profileData) => {
        setProfile(prevProfile => ({ ...prevProfile, ...profileData }));
        /**
         * Updates the profile state with the provided total work experience data.
         * Merges the existing profile state with the new total work experience data
         * and resets the expanded section state to null.
         *
         * @param {object} profileData - The new total work experience data to be merged into the existing profile state.
         */
    };

    const gapWorkExperience = (workExperienceList, educationData, certificateData) => {

        let gaps = [];
        /**
         * Calculates the difference in days between two dates.
         * @param {Date} startDate - The start date of the period to calculate.
         * @param {Date} endDate - The end date of the period to calculate.
         * @returns {number} The number of days between the start and end dates.
         */

        const calculate = (startDate, endDate) => {
            const timeDifference = startDate - endDate;
            const differenceInHours = Math.floor(timeDifference / (1000 * 60 * 60));
            const differenceInDays = Math.floor(differenceInHours / 24);
            // console.log(differenceInDay);
            return differenceInDays;
        };

        /**
         * Checks if the endDate of the work experience is within the gap period
         * and returns the gap period if it is. If not, it returns an empty object
         * and sets isupdated to true if there is an overlap.
         * @param {number} index - The index of the work experience in the list.
         * @param {Date} startDate - The start date of the work experience.
         * @param {number} gapDays - The number of days in the gap period.
         * @param {boolean} isupdated - Whether there is an overlap or not.
         * @returns {object} The gap period if there is an overlap, otherwise an empty object.
         */
        const checkEndDate = (index, startDate, gapDays, isupdated = false) => {
            let AddGap = {};
            for (let i = index + 1; i < workExperienceList.length; i++) {
                const endDate = new Date(workExperienceList[i].work_history_to);
                let gap = calculate(startDate, endDate);
                if (gap <= gapDays) {
                    gapDays = gap;
                    if (gap >= 87) {
                        const gapStartDate = new Date(startDate);
                        const gapEndDate = new Date(endDate);

                        gapStartDate.setDate(gapStartDate.getDate() - 1);
                        gapEndDate.setDate(gapEndDate.getDate() + 1);
                        AddGap = {
                            endDate: gapStartDate,
                            startDate: gapEndDate,
                        };
                        return { AddGap, isupdated: true };
                    } else {
                        isupdated = true;
                    }
                }
            }
            return { AddGap: {}, isupdated: isupdated };
        }

        if (workExperienceList?.length > 0 && !workExperienceList[0]?.present) {
            const startDate = new Date();

            const now = new Date();
            const isSameMonthAndYear =
                startDate.getMonth() === now.getMonth() &&
                startDate.getFullYear() === now.getFullYear();

            if (isSameMonthAndYear) {
                startDate.setDate(0);
            }

            const endDate = new Date(workExperienceList[0].work_history_to);
            if (calculate(startDate, endDate) >= 87) {
                const gapStartDate = new Date(startDate);
                const gapEndDate = new Date(endDate);

                gapEndDate.setDate(gapEndDate.getDate() + 1);

                gaps.push({
                    endDate: gapStartDate,
                    startDate: gapEndDate,
                });

            }
        }

        if (workExperienceList.length > 1) {
            for (let i = 1; i < workExperienceList.length; i++) {
                const startDate = new Date(workExperienceList[i - 1].work_history_from);
                const endDate = new Date(workExperienceList[i].work_history_to);
                const gapDays = calculate(startDate, endDate);
                let { AddGap, isupdated } = checkEndDate(i, startDate, gapDays);
                if (AddGap?.endDate && AddGap?.startDate) gaps.push(AddGap);
                if (gapDays >= 87 && !isupdated) {
                    const gapStartDate = new Date(startDate);
                    const gapEndDate = new Date(endDate);

                    gapStartDate.setDate(gapStartDate.getDate() - 1);
                    gapEndDate.setDate(gapEndDate.getDate() + 1);

                    gaps.push({
                        endDate: gapStartDate,
                        startDate: gapEndDate,
                    });
                }
            }
        }

        let result
        if (gaps && gaps?.length > 0 && (educationData && educationData?.length > 0 || certificateData && certificateData?.length > 0)) {
            result = adjustGapsForPeriods(gaps, educationData, certificateData);
            gaps = result;
        }
        return gaps;
    };

    /**
     * Adjusts the gaps in the work experience of a candidate to exclude any
     * periods when they were studying full time. If there is an overlap, it
     * breaks the gap into two parts: the part before the full time study period
     * and the part after the full time study period. If there is no overlap, it
     * adds the gap to the list of adjusted gaps if it is longer than 87 days.
     * @param {array} gaps - The list of gaps in the work experience of a candidate.
     * @param {array} educationData - The list of educations of a candidate.
     * @param {array} certificateData - The list of certificates of a candidate.
     * @returns {array} The list of adjusted gaps in the work experience of a candidate.
     */
    const adjustGapsForPeriods = (gaps, educationData, certificateData) => {
        const combinedData = [...educationData, ...certificateData];
        const filteredData = combinedData.filter(item =>
            item.learning_format === "Full time - offline" || item.learning_format === "Full time - online"
        );

        const periods = filteredData.map(item => ({
            from: new Date(item.education_from),
            to: new Date(item.education_to)
        }));

        const adjustedGaps = [];

        for (const gap of gaps) {
            let gapStart = new Date(gap.startDate);
            let gapEnd = new Date(gap.endDate);

            gapStart.setMonth(gapStart.getMonth());
            gapStart.setDate(1);
            gapEnd = new Date(gapEnd.getFullYear(), gapEnd.getMonth() + 1, 0);

            let hasOverlap = false;

            for (const period of periods) {
                const periodStart = new Date(period.from);
                const periodEnd = new Date(period.to);

                if (gapStart <= periodEnd && gapEnd >= periodStart) {
                    hasOverlap = true;

                    if (gapStart < periodStart) {
                        const beforeGapEnd = new Date(periodStart);
                        beforeGapEnd.setDate(beforeGapEnd.getDate() - 1);
                        const beforeGapDuration = (beforeGapEnd - gapStart) / (1000 * 60 * 60 * 24);
                        if (beforeGapDuration >= 87) {
                            adjustedGaps.push({
                                startDate: new Date(gapStart),
                                endDate: new Date(beforeGapEnd)
                            });
                        }
                    }

                    if (gapEnd > periodEnd) {
                        const afterGapStart = new Date(periodEnd);
                        afterGapStart.setMonth(afterGapStart.getMonth() + 1);
                        afterGapStart.setDate(1);
                        const afterGapDuration = (gapEnd - afterGapStart) / (1000 * 60 * 60 * 24);
                        if (afterGapDuration >= 87) {
                            adjustedGaps.push({
                                startDate: new Date(afterGapStart),
                                endDate: new Date(gapEnd)
                            });
                        }
                    }

                    break;
                }
            }

            if (!hasOverlap) {
                const gapDuration = (gapEnd - gapStart) / (1000 * 60 * 60 * 24);
                if (gapDuration >= 87) {
                    adjustedGaps.push({
                        startDate: new Date(gapStart),
                        endDate: new Date(gapEnd)
                    });
                }
            }
        }

        return adjustedGaps;
    };

    const executeResumeUpdate = async (newlyAddedWorkHistory = []) => {
        setLoads(true);

        try {
            const finalResumeId = isMaster ? candidateData?.master_resume_id : resumeId;
            const combinedWorkHistory = [
                ...workHistory,
                ...newlyAddedWorkHistory
            ];

            const uniqueWorkHistory = Array.from(new Map(combinedWorkHistory.map(item => [item._id || item.work_history_from, item])).values());

            const cleanedEducations = educations.filter(e => e._id || e.status === 'active');
            const cleanedWorkHistory = uniqueWorkHistory.filter(w => w._id || w.status === 'active');
            const cleanedCertificates = certificates.filter(c => c._id || c.status === 'active');

            const resumePayload = {
                title: resumeTitleText?.trim(),
                profile,
                summary,
                educations: cleanedEducations,
                work_history: cleanedWorkHistory,
                certificates: cleanedCertificates,
                finance_technologies: financeTechologiesData,
                custom_section: customSection,
                deleteEducationHistoryIds,
                deleteCertificateHistoryIds,
                deleteWorkHistoryIds,
                resumeLink,
                resumeWordLink
            };

            const response = await updateResumeData({ resumeId: finalResumeId, resumePayload });

            if (response?.success && response?.data?.user) {
                const candidate = response.data.user;

                updateContext({
                    name: candidate.full_name || '',
                    sex: candidate.sex || null,
                    date_of_birth: candidate.date_of_birth || null,
                    city: candidate.address?.city || '',
                    email: candidate.email || '',
                    phone_number: candidate.phone_number || '',
                    is_phone_verified: candidate.is_phone_verified || false,
                    is_email_verified: candidate.is_email_verified || false,
                    disability: candidate.disability || '',
                    phone: candidate.phone_number || '',
                    photo: candidate?.photo ? candidate?.photo?.includes('http') ? candidate.photo : `${process.env.REACT_APP_END_POINT}${candidate.photo}` : '',
                });

                const successMessage = (createNewResume || isDuplicate || isMaster)
                    ? "Resume created successfully"
                    : "Resume updated successfully";

                enqueueSnackbar(successMessage, { variant: 'success' });
                const resume = response?.data?.updatedResume;
                resume.work_history = reorderWorkHistory(resume?.work_history);
                if (jobApply?.openChatBot && createNewResume) {
                    setJobApply(prev => ({
                        ...prev,
                        resume: resume
                    }));
                }

                if (jobApply?.openChatBot) navigate('/home', { state: { data: jobData } });
                else navigate('/home', { state: { tab: '4', data: jobData || null, resumeId: finalResumeId } });

            } else {
                enqueueSnackbar('Failed to update resume.', { variant: 'error' });
            }
        } catch (error) {
            console.error('Error updating resume:', error);
            enqueueSnackbar('An error occurred while updating the resume.', { variant: 'error' });
        } finally {
            setLoads(false);
        }
    };
    const handleValidateResume = async () => {
        const requiredFields = {
            ...(uploadResume ? { resume: resume || resumeLink } : {}),
            'personal details': profile?.date_of_birth && profile?.city && profile?.sex && profile?.name,
            'contact details': profile?.email && profile?.phone,
            education: educations?.length > 0,
            'work history': workHistory?.length > 0,
        };

        const missingFields = Object.keys(requiredFields).filter(field => !requiredFields[field]);

        if (missingFields.length > 0) {
            const missingFieldsString = missingFields.join(', ').replace(/,([^,]*)$/, ' and$1');
            enqueueSnackbar(`Please complete your ${missingFieldsString}.`, { variant: 'error' });
            return false;
        }

        const trimmedTitle = resumeTitleText?.trim();
        if (!trimmedTitle) {
            enqueueSnackbar('Title cannot be empty', { variant: 'error' });
            return false;
        }
        if (allResumeTitle?.some(title => title?.toLowerCase() === trimmedTitle.toLowerCase())) {
            enqueueSnackbar('Title already exists', { variant: 'error' });
            return false;
        }

        return true;
    };
    const handleBack = () => {
        if (jobApply?.openChatBot) navigate('/home');
        else navigate('/home', { state: { tab: '4', data: jobData || null, resumeId } });
    };
    const handleSaveTitle = () => {
        const trimmedTitle = resumeTitleText?.trim();

        if (!trimmedTitle) {
            enqueueSnackbar('Title cannot be empty', { variant: 'error' });
            return;
        }
        if (allResumeTitle?.some(title => title?.toLowerCase() === trimmedTitle.toLowerCase())) {
            enqueueSnackbar('Title already exists', { variant: 'error' });
            return;
        }

        setIsClicked(true);
        setIsEditResumeTitle(false);
        setIsEditTitle(true);
    };
    const hasIncompleteSections = () => {
        const getItem = (key) => JSON.parse(localStorage.getItem(key) || 'null');
        return getItem('workExperience') || getItem('education') || getItem('certificate');
    };

    const handleResumeValidation = async () => {
        setLoads(true);
        const isValid = await handleValidateResume();
        if (!isValid) {
            setLoads(false);
            return;
        }

        if (hasIncompleteSections()) {
            handleOpenIncompleteDialog();
            setLoads(false);
            return;
        }


        if (!uploadResume || isCreatedMasterResume) {
            // const gap = gapWorkExperience(workExperienceData?.filter(item => item?._id), educationData, certificateData);

            if (!isCreatedMasterResume) {
                setLoads(false);
                workGapAnalysis();
                setIsCreatedMasterResume(true);
                return;
            }

            let filterWithoutReason = [];
            const updatedWorkHistory = calculateWorkGap();
            if (updatedWorkHistory?.length > 0) {
                const workGapList = updatedWorkHistory?.filter(edu => edu?.organization_name === 'Work Gap');
                if (workGapList?.length > 0) {
                    filterWithoutReason = workGapList?.filter(edu => !edu?.gap_explaination || !edu?.gap_title);
                    if (filterWithoutReason?.length > 0) {
                        setGap(filterWithoutReason);
                    }
                }
            }
            console.log(filterWithoutReason);
            if (filterWithoutReason && filterWithoutReason.length > 0) {
                handleOpenCareerBreakDialog();
                setLoads(false);
                return;
            }
        }
        await executeResumeUpdate();
    };

    const calculateWorkGap = () => {
        let updatedWorkHistory = [];
        setWorkHistory(prev => {
            // Make a safe copy
            updatedWorkHistory = structuredClone(prev);

            // ✅ Replace backend queries with props/state variables
            const workHistoryList = updatedWorkHistory; // Already in state
            const educationList = educations.filter(
                edu => edu?.learning_format === 'Full time - offline'
            );
            const certificationList = certificates.filter(
                cert => cert?.learning_format === 'Full time - offline'
            );

            // Separate gaps and non-gaps
            const existingGaps = workHistoryList.filter(
                h => h.organization_name === 'Work Gap'
            );
            const pureWorkHistories = workHistoryList.filter(h => h.organization_name !== 'Work Gap' && h.job_type?.toLowerCase() !== 'internship');


            if (pureWorkHistories.length > 0 && (!resumeLink || candidateData?.is_master_resume)) {
                console.log('Work Gap Analysis');
            } else {
                return workHistoryList;
            }

            // Call your gap calculation logic
            let { updatedHistories, retainedGaps } = calcWorkGap(
                pureWorkHistories,
                educationList,
                certificationList,
                existingGaps,
            );

            // Mark retained gaps for the frontend
            retainedGaps = retainedGaps.map(rWg => ({
                ...rWg,
                status: 'active',
                _id: new ObjectId().toString(),
                isNew: true,
            }));


            // ----- FRONTEND REPLACEMENT FOR BACKEND DELETE/INSERT -----

            // 1. Delete old gaps
            const oldWorkGapsIds = existingGaps.map(doc => doc._id);
            const oldUpdatedGapIds = existingGaps.filter(doc => doc._id && !doc?.isNew).map(doc => doc._id);
            setDeleteWorkHistoryIds(prevIds => [...prevIds, ...oldUpdatedGapIds]);
            updatedWorkHistory = updatedWorkHistory.filter(
                w => !oldWorkGapsIds.includes(w._id)
            );

            // 2. Insert new gaps
            updatedWorkHistory = [...updatedWorkHistory, ...retainedGaps];
            console.log(updatedWorkHistory);
            return reorderWorkHistory(updatedWorkHistory);
        });

        return updatedWorkHistory;
    };

    const handleRemoveIncompleteData = () => {
        handleCloseIncompleteDialog();
        handleResumeValidation()
    };

    const handleProceedFromGapDialog = (newGapData = []) => {
        handleCloseCareerBreakDialog();
        // executeResumeUpdate(newGapData);
    };

    const handleOpenUpdateDialog = (contactType) => {
        setContactToUpdate(contactType);
        handleOpenUpdateContactDialog();
    };

    const handleCloseUpdateDialog = () => {
        handleCloseUpdateContactDialog();
        setContactToUpdate('');
    };

    if (loading) return <SplashScreen />

    return (
        <Box>
            <Box>
                <Container maxWidth="xl" disableGutters>
                    <Grid container>
                        <Grid item xs={12} md={uploadResume ? 12 : 7} lg={uploadResume ? 12 : 7}>
                            <Box className="candidate-details-content">
                                <Box className="candidate-det-wrapper" >
                                    <Box mb={2.5}>
                                        <Stack spacing={2.5}>
                                            {jobData && !isExternalJob && <Box className="back-to-page">
                                                <Stack direction="row" alignItems={'center'} spacing={0.5}>
                                                    <IconButton aria-label="delete" sx={{ padding: 0 }} disableRipple onClick={handleBack}>
                                                        <SvgIcon>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                <path d="M17.6991 9.41134H3.931L8.27882 5.30124C8.55056 5.04436 8.55056 4.61623 8.27882 4.35935C8.00708 4.10247 7.55418 4.10247 7.28245 4.35935L1.84766 9.58259C1.75708 9.66822 1.6665 9.83947 1.6665 10.0107C1.6665 10.182 1.75708 10.3532 1.84766 10.4389L7.28245 15.6621C7.37303 15.7477 7.55418 15.8334 7.73534 15.8334C7.9165 15.8334 8.09766 15.7477 8.18824 15.6621C8.45998 15.4052 8.45998 14.9771 8.18824 14.7202L3.84042 10.6101H17.6085C17.9709 10.6101 18.3332 10.3532 18.3332 9.9251C18.3332 9.49696 18.0614 9.41134 17.6991 9.41134Z" fill="#808080" />
                                                            </svg>
                                                        </SvgIcon>
                                                        <Typography className="back-text" variant="body1">Back to job application</Typography>
                                                    </IconButton>
                                                </Stack>
                                            </Box>}

                                            <Box display="flex" alignItems="center" gap={1}>
                                                {uploadResume &&
                                                    <Typography className="page-heading" variant="h5">
                                                        <Typography variant="body">Master Profile</Typography>
                                                        {uploadResume &&
                                                            <Typography className="step-info" variant="body2" gutterBottom>
                                                                Please update relevant master profile information here
                                                            </Typography>}
                                                    </Typography>
                                                }
                                                {!uploadResume && <Box >
                                                    {isEditResumeTitle ? (
                                                        <TextField
                                                            type="text"
                                                            variant="standard"
                                                            autoFocus
                                                            value={resumeTitleText}
                                                            onChange={(e) => {
                                                                setResumeTitleText(e.target.value);
                                                                setIsChange(true);
                                                                setExpandedSection({ section: null, index: null });
                                                            }}
                                                            onBlur={handleSaveTitle}
                                                        />
                                                    ) : (
                                                        <Typography className="page-heading" variant="h5">
                                                            <Typography variant="body">{resumeTitleText}</Typography>
                                                        </Typography>
                                                    )}
                                                </Box>}

                                                {(!isMasterResume && !uploadResume && isEditTitle) ?
                                                    <IconButton aria-label="edit" disabled={isMasterResume || uploadResume} onClick={() => {
                                                        setIsClicked(false);
                                                        handleEditResumeTitle();
                                                    }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M12.2872 16.0003H2.09789C0.941117 16.0003 0 15.0593 0 13.9024V3.71313C0 2.55635 0.941002 1.61523 2.09789 1.61523H6.76704C7.0982 1.61523 7.36641 1.88345 7.36641 2.2146C7.36641 2.54576 7.0982 2.81398 6.76704 2.81398H2.09789C1.60192 2.81398 1.19884 3.21706 1.19884 3.71303V13.9023C1.19884 14.3983 1.60192 14.8014 2.09789 14.8014H12.2872C12.7832 14.8014 13.1862 14.3983 13.1862 13.9023V9.23319C13.1862 8.90203 13.4545 8.63381 13.7856 8.63381C14.1168 8.63381 14.385 8.90203 14.385 9.23319V13.9023C14.385 15.0591 13.4441 16.0003 12.2872 16.0003Z" fill="#1F9CD7" />
                                                            <path d="M4.44141 9.00838L10.9986 2.45117L13.5451 4.99768L6.98792 11.5549L4.44141 9.00838Z" fill="#1F9CD7" />
                                                            <path d="M15.7098 1.43961L14.5591 0.28882C14.174 -0.0962733 13.5491 -0.0962733 13.1633 0.28882L11.8477 1.60444L14.3942 4.15095L15.7098 2.83533C16.0949 2.45024 16.0949 1.82545 15.7098 1.43961Z" fill="#1F9CD7" />
                                                            <path d="M3.67143 9.9353L3.07881 12.523C3.02487 12.7598 3.23615 12.9711 3.4729 12.9171L6.06065 12.3245L3.67143 9.9353Z" fill="#1F9CD7" />
                                                        </svg>
                                                    </IconButton> :
                                                    ""
                                                }

                                            </Box>
                                        </Stack>
                                    </Box>

                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                    {uploadResume && <>
                                        <UploadExistingProfile onProfilePhotoChange={handleProfilePhotoChange} setResume={setResume} isResume={true} handleUploadResume={handleUploadResume} />
                                        <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                    </>}
                                    <UploadProfile profilephoto={profilephoto} setUpdating={setUpdating} onProfilePhotoChange={handleProfilePhotoChange} isResume={true} handleResumeProfile={handleResumeProfile} profileData={profile} />
                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                    <PersonalDetails profileData={profile} ref={personalDetailRef} setUpdating={setUpdating} hideBox={true} isResume={true} handleResumeProfile={handleResumeProfile} />
                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                    <ContactDetails profileData={profile} contactDetailsError={contactDetailsError} setUpdating={setUpdating} isResume={true} handleResumeProfile={handleResumeProfile} isUpdateContactOpen={isUpdateContactOpen}
                                        contactToUpdate={contactToUpdate}
                                        onOpenUpdateDialog={handleOpenUpdateDialog}
                                        onCloseUpdateDialog={handleCloseUpdateDialog} />
                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                    <EducationSection scrollToChild={scrollToChild} educationData={educations} setUpdating={setUpdating} onCancel={handleCancelEducation} onEducationDataChange={handleEducationDataChange} expandedSection={expandedSection} handleExpand={handleExpand} certificateData={certificates} workExperienceData={workHistory} showEdu={true} handleShowEdu={handleShowEdu} handleEducationDelete={handleEducationDelete} uploadResume={uploadResume} />
                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                    <WorkExperienceDetails scrollToChild={scrollToChild} setUpdating={setUpdating} workExperienceData={workHistory} onCancel={handleCancelEducation} onWorkExperienceDataChange={handleWorkExperienceDataChange} expandedSection={expandedSection} handleExpand={handleExpand} certificateData={certificates} educationData={educations} showWork={true} handleShowWork={handleShowWork} handleDeleteWorks={handleDeleteWorks} uploadResume={uploadResume} />
                                    {uploadResume && <TotalWorkExperienceDisplay isResume={true} handleResumeProfile={handleTotalWorkExperience} workExperienceData={workHistory} candidateData={candidateData} />}
                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                    <FinanceTechnicalCompetencies financeTechologiesData={financeTechologiesData} setUpdating={setUpdating} onFinanceDataChange={handleFinanceDataChange} Finance={true} handleFinance={handleFinance} />
                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                    {!uploadResume && <><CertificationSection scrollToChild={scrollToChild} setUpdating={setUpdating} certificateData={certificates} onCancel={handleCancelEducation} onCertificateDataChange={handleCertificateDataChange} expandedSection={expandedSection} handleExpand={handleExpand} educationData={educations} workExperienceData={workHistory} showCert={true} handleShowCert={handleShowCert} handleDeleteCert={handleDeleteCert} />
                                        <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                    </>}
                                    {!uploadResume && <><ProfessionalSummary summaryData={summary} setUpdating={setUpdating} onSummaryDataChange={handleSummaryDataChange} Summary={true} handleSummary={handleSummary} />
                                        <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                    </>}
                                    {!uploadResume && <><CustomSection customSectionData={customSection} flag={flag} setUpdating={setUpdating} onCustomDataChange={handleCustomSectionDataChange} custom={true} handleCustom={handleCustom} handleDeleteCustom={handleDeleteCustom} />
                                        <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                    </>}
                                    {!uploadResume && <><Disability profileData={profile} setUpdating={setUpdating} hideBox={true} isResume={true} handleResumeProfile={handleResumeProfile} />
                                        <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} /></>}
                                    {/* Preview resume in mobile view */}
                                    {!uploadResume && (showFirstButton ?
                                        <Box className='pre-resume-full-btn-block' sx={{ display: { xs: 'flex', md: 'none' } }} mb={1}>
                                            <Button disableRipple variant="contained" endIcon={
                                                <SvgIcon sx={{ margin: 0 }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7554 2.26088C10.6311 2.1352 10.5611 1.96605 10.5611 1.78942V0.17393L12.8547 2.46053H11.227C11.0497 2.45918 10.8804 2.38723 10.7554 2.26088ZM13.0163 2.78262V15.1671C13.0156 15.6243 12.6467 15.9959 12.1889 16H1.81653C1.35662 15.9993 0.984321 15.6264 0.983643 15.1671V0.832885C0.984322 0.373651 1.3566 0.000678259 1.81653 0H10.2268V1.79478C10.2288 2.34641 10.6751 2.79274 11.2268 2.79478L13.0163 2.78262ZM3.97284 5.13583C3.97284 6.074 4.4083 6.95983 5.15287 7.53183C5.89742 8.10316 6.86551 8.29677 7.77182 8.05424C8.67874 7.81172 9.42128 7.16158 9.78138 6.29407C10.1408 5.42722 10.0769 4.44225 9.60815 3.62904C9.13872 2.81585 8.31874 2.26763 7.38798 2.14466C6.45727 2.02169 5.52242 2.33827 4.85877 3.00199C4.29219 3.57196 3.97698 4.34439 3.98378 5.14808L3.97284 5.13583ZM9.53804 13.6922C9.53804 13.646 9.52038 13.6018 9.48709 13.5692C9.45448 13.5366 9.41032 13.5183 9.36413 13.5183H2.62501C2.5727 13.5019 2.51496 13.5115 2.4708 13.5441C2.42596 13.5767 2.40015 13.629 2.40015 13.684C2.40015 13.7397 2.42596 13.7913 2.4708 13.824C2.51496 13.8572 2.5727 13.8668 2.62501 13.8505H9.38048C9.46336 13.8477 9.53401 13.7866 9.54692 13.7044L9.53804 13.6922ZM11.538 12.2173C11.538 12.1711 11.5204 12.1269 11.4871 12.0943C11.4545 12.0617 11.4103 12.0434 11.3641 12.0434H2.62501C2.5727 12.0278 2.51632 12.0386 2.47216 12.0712C2.42868 12.1038 2.40287 12.1555 2.40287 12.2105C2.40287 12.2649 2.42868 12.3165 2.47216 12.3498C2.51632 12.3824 2.5727 12.3926 2.62501 12.3776H11.3805C11.464 12.3749 11.5347 12.3124 11.5469 12.2295L11.538 12.2173ZM11.538 10.7424C11.538 10.6962 11.5204 10.6521 11.4871 10.6195C11.4545 10.5869 11.4103 10.5685 11.3641 10.5685H2.62501C2.55096 10.5903 2.50001 10.6582 2.50001 10.7356C2.50001 10.8131 2.55096 10.881 2.62501 10.9028H11.3805C11.464 10.9 11.5347 10.8375 11.5469 10.7547L11.538 10.7424ZM11.538 9.26756C11.538 9.22137 11.5204 9.17721 11.4871 9.1446C11.4545 9.11199 11.4103 9.09365 11.3641 9.09365H2.62501C2.55096 9.11539 2.50001 9.18332 2.50001 9.26077C2.50001 9.33821 2.55096 9.40615 2.62501 9.42789H11.3805C11.464 9.42517 11.5347 9.36335 11.5469 9.27979L11.538 9.26756ZM4.91718 6.83279H4.91786C4.48511 6.30562 4.26976 5.63442 4.31459 4.95366C4.35943 4.27363 4.66106 3.63641 5.15903 3.17036C5.65631 2.70432 6.31255 2.44549 6.99398 2.44549C7.67605 2.44549 8.33161 2.70432 8.82963 3.17036C9.32691 3.63639 9.62855 4.27363 9.67338 4.95366C9.71822 5.63437 9.50286 6.30555 9.07081 6.83279C8.94105 6.45167 8.70737 6.11404 8.39622 5.85927C7.99676 5.55425 7.50492 5.39595 7.00288 5.41023C6.49541 5.39936 6.00017 5.56512 5.60139 5.8783C5.29024 6.13374 5.05656 6.47068 4.92612 6.85181L4.91718 6.83279ZM5.85468 4.13923C5.85536 4.68745 6.24259 5.15961 6.78062 5.26627C7.31866 5.37293 7.85738 5.08488 8.06662 4.57809C8.27653 4.07062 8.09855 3.48639 7.64203 3.18205C7.18551 2.8777 6.57817 2.93885 6.19026 3.32675C5.9749 3.5421 5.854 3.8342 5.85468 4.13923ZM7.00278 4.95309C7.39205 4.95309 7.72697 4.67863 7.80305 4.29684C7.87914 3.91505 7.67466 3.53258 7.31528 3.3838C6.95523 3.23502 6.54083 3.3607 6.3248 3.68476C6.10876 4.00881 6.15156 4.4395 6.42738 4.71465C6.57955 4.86818 6.78674 4.95376 7.00278 4.95309ZM8.19571 6.13719C7.85605 5.8702 7.43485 5.72957 7.00278 5.73908C6.14137 5.70308 5.37847 6.28936 5.19026 7.13038C5.68619 7.58216 6.33224 7.83284 7.00278 7.83284C7.67331 7.83284 8.31935 7.58216 8.81529 7.13038C8.72155 6.74112 8.50481 6.39261 8.19571 6.13719Z" fill="white" />
                                                    </svg>
                                                </SvgIcon>
                                            } onClick={handlePreviewResumeOpen}>
                                                Preview Resume
                                            </Button>
                                        </Box> :
                                        <Box className='pre-resume-btn-block' sx={{ display: { xs: 'flex', md: 'none' } }} mb={1}>
                                            <IconButton aria-label="delete" onClick={handlePreviewResumeOpen}>
                                                <SvgIcon sx={{ width: '12px', height: '16px' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7554 2.26088C10.6311 2.1352 10.5611 1.96605 10.5611 1.78942V0.17393L12.8547 2.46053H11.227C11.0497 2.45918 10.8804 2.38723 10.7554 2.26088ZM13.0163 2.78262V15.1671C13.0156 15.6243 12.6467 15.9959 12.1889 16H1.81653C1.35662 15.9993 0.984321 15.6264 0.983643 15.1671V0.832885C0.984322 0.373651 1.3566 0.000678259 1.81653 0H10.2268V1.79478C10.2288 2.34641 10.6751 2.79274 11.2268 2.79478L13.0163 2.78262ZM3.97284 5.13583C3.97284 6.074 4.4083 6.95983 5.15287 7.53183C5.89742 8.10316 6.86551 8.29677 7.77182 8.05424C8.67874 7.81172 9.42128 7.16158 9.78138 6.29407C10.1408 5.42722 10.0769 4.44225 9.60815 3.62904C9.13872 2.81585 8.31874 2.26763 7.38798 2.14466C6.45727 2.02169 5.52242 2.33827 4.85877 3.00199C4.29219 3.57196 3.97698 4.34439 3.98378 5.14808L3.97284 5.13583ZM9.53804 13.6922C9.53804 13.646 9.52038 13.6018 9.48709 13.5692C9.45448 13.5366 9.41032 13.5183 9.36413 13.5183H2.62501C2.5727 13.5019 2.51496 13.5115 2.4708 13.5441C2.42596 13.5767 2.40015 13.629 2.40015 13.684C2.40015 13.7397 2.42596 13.7913 2.4708 13.824C2.51496 13.8572 2.5727 13.8668 2.62501 13.8505H9.38048C9.46336 13.8477 9.53401 13.7866 9.54692 13.7044L9.53804 13.6922ZM11.538 12.2173C11.538 12.1711 11.5204 12.1269 11.4871 12.0943C11.4545 12.0617 11.4103 12.0434 11.3641 12.0434H2.62501C2.5727 12.0278 2.51632 12.0386 2.47216 12.0712C2.42868 12.1038 2.40287 12.1555 2.40287 12.2105C2.40287 12.2649 2.42868 12.3165 2.47216 12.3498C2.51632 12.3824 2.5727 12.3926 2.62501 12.3776H11.3805C11.464 12.3749 11.5347 12.3124 11.5469 12.2295L11.538 12.2173ZM11.538 10.7424C11.538 10.6962 11.5204 10.6521 11.4871 10.6195C11.4545 10.5869 11.4103 10.5685 11.3641 10.5685H2.62501C2.55096 10.5903 2.50001 10.6582 2.50001 10.7356C2.50001 10.8131 2.55096 10.881 2.62501 10.9028H11.3805C11.464 10.9 11.5347 10.8375 11.5469 10.7547L11.538 10.7424ZM11.538 9.26756C11.538 9.22137 11.5204 9.17721 11.4871 9.1446C11.4545 9.11199 11.4103 9.09365 11.3641 9.09365H2.62501C2.55096 9.11539 2.50001 9.18332 2.50001 9.26077C2.50001 9.33821 2.55096 9.40615 2.62501 9.42789H11.3805C11.464 9.42517 11.5347 9.36335 11.5469 9.27979L11.538 9.26756ZM4.91718 6.83279H4.91786C4.48511 6.30562 4.26976 5.63442 4.31459 4.95366C4.35943 4.27363 4.66106 3.63641 5.15903 3.17036C5.65631 2.70432 6.31255 2.44549 6.99398 2.44549C7.67605 2.44549 8.33161 2.70432 8.82963 3.17036C9.32691 3.63639 9.62855 4.27363 9.67338 4.95366C9.71822 5.63437 9.50286 6.30555 9.07081 6.83279C8.94105 6.45167 8.70737 6.11404 8.39622 5.85927C7.99676 5.55425 7.50492 5.39595 7.00288 5.41023C6.49541 5.39936 6.00017 5.56512 5.60139 5.8783C5.29024 6.13374 5.05656 6.47068 4.92612 6.85181L4.91718 6.83279ZM5.85468 4.13923C5.85536 4.68745 6.24259 5.15961 6.78062 5.26627C7.31866 5.37293 7.85738 5.08488 8.06662 4.57809C8.27653 4.07062 8.09855 3.48639 7.64203 3.18205C7.18551 2.8777 6.57817 2.93885 6.19026 3.32675C5.9749 3.5421 5.854 3.8342 5.85468 4.13923ZM7.00278 4.95309C7.39205 4.95309 7.72697 4.67863 7.80305 4.29684C7.87914 3.91505 7.67466 3.53258 7.31528 3.3838C6.95523 3.23502 6.54083 3.3607 6.3248 3.68476C6.10876 4.00881 6.15156 4.4395 6.42738 4.71465C6.57955 4.86818 6.78674 4.95376 7.00278 4.95309ZM8.19571 6.13719C7.85605 5.8702 7.43485 5.72957 7.00278 5.73908C6.14137 5.70308 5.37847 6.28936 5.19026 7.13038C5.68619 7.58216 6.33224 7.83284 7.00278 7.83284C7.67331 7.83284 8.31935 7.58216 8.81529 7.13038C8.72155 6.74112 8.50481 6.39261 8.19571 6.13719Z" fill="white" />
                                                    </svg>
                                                </SvgIcon>
                                            </IconButton>
                                        </Box>)
                                    }
                                    <Box className="form-action-btn" sx={{ display: { xs: 'none', md: 'block' } }}>
                                        <Stack direction="row" spacing={{ xs: 0, md: 2 }} mt={{ xs: 0, md: 3 }}>
                                            <Button fullwidth sx={{ width: { xs: '100%', sm: 'auto' } }} onClick={handleOpenLeaveWihoutUpdatingDialog} className="text-button" size="medium" disableRipple disableElevation>Cancel</Button>
                                            <Button
                                                fullWidth
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '8px',
                                                    whiteSpace: 'nowrap',
                                                    width: { xs: '100%', sm: 'auto' },
                                                    backgroundColor: '#1575c6',
                                                    borderRadius: '12px',
                                                    padding: '10px'
                                                }}
                                                variant="contained"
                                                className="nxt-btn"
                                                onClick={() => handleResumeValidation()}
                                                disabled={
                                                    loads ||
                                                    (!isChange && !createNewResume && !isDuplicate && !isMaster)
                                                }
                                            >
                                                {loads ? ((createNewResume || isDuplicate || isMaster) ? 'Creating...' : 'Updating...') : ((createNewResume || isDuplicate || isMaster) ? 'Create Resume' : `Update ${jobData && !isExternalJob ? '& Continue Applying' : uploadResume ? 'Profile' : 'Resume'}`)}
                                            </Button>

                                        </Stack>

                                    </Box>

                                </Box>
                                <Box className="form-action-btn" sx={{ display: { xs: 'block', md: 'none' } }}>
                                    <Stack direction="row" spacing={{ xs: 0, md: 2 }} mt={{ xs: 0, md: 3 }}>
                                        <Button fullwidth sx={{ width: { xs: '100%', sm: 'auto' } }} onClick={handleOpenLeaveWihoutUpdatingDialog} className="text-button" size="medium" disableRipple disableElevation>Cancel</Button>
                                        <Button
                                            fullWidth
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '8px',
                                                whiteSpace: 'nowrap',
                                                width: { xs: '100%', sm: 'auto' },
                                                backgroundColor: '#1575c6',
                                                borderRadius: '12px',
                                                padding: '10px'
                                            }}
                                            variant="contained"
                                            className="nxt-btn"
                                            onClick={() => handleResumeValidation()}
                                            disabled={
                                                loads ||
                                                (!isChange && !createNewResume && !isDuplicate && !isMaster)
                                            }
                                        >
                                            {loads ? ((createNewResume || isDuplicate || isMaster) ? 'Creating...' : 'Updating...') : ((createNewResume || isDuplicate || isMaster) ? 'Create Resume' : `Update ${jobData && !isExternalJob ? '& Apply' : uploadResume ? 'Profile' : 'Resume'}`)}
                                        </Button>

                                    </Stack>

                                </Box>
                            </Box>
                        </Grid>
                        <Grid item md={5} lg={5} sx={{ display: { xs: 'none', md: uploadResume ? 'none' : 'block' } }}>
                            <CandidateResume
                                updating={updating}
                                setUpdating={setUpdating}
                                title={resumeTitleText}
                                profile={profile}
                                summaryData={summary}
                                educationData={educations}
                                workExperienceData={workHistory}
                                certificateData={certificates}
                                financeTechologiesData={financeTechologiesData}
                                customSection={customSection}
                            />
                        </Grid>
                    </Grid>
                </Container>
                {/* Leave without updating changes dialog */}
                {isMobile ?
                    <Drawer
                        anchor="bottom"
                        open={withoutUpdateDialog}
                        onClose={handleCloseLeaveWihoutUpdatingDialog}
                        className="forgot-password-dialog career-breaks-dialog"
                    >
                        <LeaveWithoutUpdatingDialog updateResume={executeResumeUpdate} resumeId={resumeId} handleClose={handleCloseLeaveWihoutUpdatingDialog} isCreateResume={(createNewResume || isDuplicate)} />
                    </Drawer> :
                    <Dialog
                        open={withoutUpdateDialog}
                        onClose={handleCloseLeaveWihoutUpdatingDialog}
                        className="action-dialog-card"
                    >
                        <LeaveWithoutUpdatingDialog updateResume={executeResumeUpdate} resumeId={resumeId} handleClose={handleCloseLeaveWihoutUpdatingDialog} isCreateResume={(createNewResume || isDuplicate)} />
                    </Dialog>
                }

                {/* Preview Resume Dialog */}
                <Dialog
                    fullScreen
                    open={previewResume}
                    onClose={handlePreviewResumeClose}
                    TransitionComponent={Transition}
                    className='preview-resume-dialog'
                >
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <Typography className="preview-resume-title" sx={{ ml: 1, flex: 1 }} variant="h6" component="div">
                                Resume Preview
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handlePreviewResumeClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    {/* Candidate Resume Component */}
                    <CandidateResume
                        updating={updating}
                        setUpdating={setUpdating}
                        title={resumeTitleText}
                        profile={profile}
                        summaryData={summary}
                        educationData={educations}
                        workExperienceData={workHistory}
                        certificateData={certificates}
                        financeTechologiesData={financeTechologiesData}
                        customSection={customSection}
                    />
                </Dialog>
            </Box>
            {/* incomplete dialog */}
            {isMobile ?
                <Drawer
                    anchor="bottom"
                    open={openIncompleteDialog}
                    onClose={() => handleCloseIncompleteDialog()}
                    className="forgot-password-dialog otp-dialog-wrapper"
                >
                    <IncompleteSectionDialog
                        onClose={() => handleCloseIncompleteDialog()}
                        navigateTo={() => handleRemoveIncompleteData()} />
                </Drawer> :
                <Dialog
                    open={openIncompleteDialog}
                    onClose={() => handleCloseIncompleteDialog()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className="otp-dialog-wrapper"
                >
                    <IncompleteSectionDialog
                        onClose={() => handleCloseIncompleteDialog()}
                        navigateTo={() => handleRemoveIncompleteData()} />
                </Dialog>}
            {/* career break dialog */}
            {isMobile ?
                <Drawer
                    anchor="bottom"
                    open={openCareerGapDialog}
                    onClose={() => handleCloseCareerBreakDialog()}
                    className="forgot-password-dialog career-breaks-dialog"
                >
                    <CareerBreaksIdentifiedDialog gap={workExperienceGap} onClose={() => handleCloseCareerBreakDialog()} onProceed={handleProceedFromGapDialog} onWorkExperienceDataChange={handleWorkExperienceDataChange} isResume={true} handleWorkGapChange={handleWorkGapChange} />
                </Drawer> :
                <Dialog
                    open={openCareerGapDialog}
                    onClose={() => handleCloseCareerBreakDialog()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className="career-breaks-dialog"
                >
                    <CareerBreaksIdentifiedDialog gap={workExperienceGap} onClose={() => handleCloseCareerBreakDialog()} onProceed={handleProceedFromGapDialog} onWorkExperienceDataChange={handleWorkExperienceDataChange} isResume={true} handleWorkGapChange={handleWorkGapChange} />
                </Dialog>}
        </Box>
    )
}

export default CreateUpdateResume;
